import { graphql } from '../graphql';

export const startLandxmlMerge = graphql(`
  mutation StartLandxmlMerge($input: StartLandxmlMergeInput!) {
    startLandxmlMerge(input: $input)
  }
`);

export const previewLandxmlMergeCleanupQuery = graphql(`
  query PreviewLandxmlMergeCleanup($resultLayerId: ID!) {
    previewLandxmlMergeCleanup(resultLayerId: $resultLayerId) {
      eligible
      reason
      fingerprint
      sourceLayerNames
      uploadBatchCount
      uploadBatches { id label }
      attachmentCount
      storageBytes
      operationId
    }
  }
`);

export const executeLandxmlMergeCleanupMutation = graphql(`
  mutation ExecuteLandxmlMergeCleanup($resultLayerId: ID!, $fingerprint: String!) {
    executeLandxmlMergeCleanup(resultLayerId: $resultLayerId, fingerprint: $fingerprint) {
      id
      status
    }
  }
`);

export const landxmlMergeCleanupOperationQuery = graphql(`
  query LandxmlMergeCleanupOperation($projectId: ID!, $id: ID!) {
    deletionOperation(projectId: $projectId, id: $id) {
      id
      status
      completedTargets
      totalTargets
      lastError
    }
  }
`);
